export default {
      id: "shopping-basket-usage",
      viewBox: "0 0 60 61",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#shopping-basket",
      toString: function () {
        return this.url;
      }
    }